export default "/_next/static/images/section-3-7d21c9afa5bbefd152440f328d237037.png";